import { VolcanoOutlineIcon } from './VolcanoOutlineIcon';

/**
 * author: Google
 * id EF1E667D-78DD-4460-BD7B-B5E7A70BDF54
 * name volcano-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/volcano-outline.svg
 * tags
 * - Nature 
 */
export const EruptionOutlineIcon = VolcanoOutlineIcon;
export default EruptionOutlineIcon